import { useState } from 'react';
import {
    TextField,
    Button,
    Container,
    Typography,
    Box,
    InputAdornment,
    IconButton
  } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useCurrentScreen } from '../hooks/screen/useCurrentScreen';
import { useGuestGuard } from '../hooks/auth/useGuestGuard';
import { login } from '../services/authService';
import { useToast } from '../hooks/toast/useToast';

const Login = () => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { error } = useToast();

  useCurrentScreen('Login');
  const { isGuest } = useGuestGuard();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await login(email, password);
    if(result?.status !== 200){
      error(result?.error || 'Erro ao logar');
    }
  };

  if (!isGuest) {
    return null;
  }

  return (
    <Container>
      <Box mt={10} textAlign="center">
        <Typography variant="h4" gutterBottom>
          {process.env.REACT_APP_TITLE} - Login
        </Typography>
        <Container maxWidth="xs">
          <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <TextField
              required
              fullWidth
              type="email"
              label="E-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
            />
            <TextField
              required
              fullWidth
              type={showPassword ? 'text' : 'password'}
              label="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              InputProps={{
                  endAdornment: (
                  <InputAdornment position="end">
                      <IconButton
                      onClick={() => setShowPassword((prev) => !prev)}
                      edge="end"
                      >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                  </InputAdornment>
                  )
              }}
              />
            <Box mt={2}>
              <Button type="submit" fullWidth variant="contained">
                Entrar
              </Button>
            </Box>
          </form>
        </Container>
      </Box>
    </Container>
  );
};

export default Login;